export default "__VITE_ASSET__dK3MLjpK__"